// extracted by mini-css-extract-plugin
export var badge = "_sk-4";
export var selected = "_sk-1";
export var selectedOverlay = "_sk-5";
export var thumbnailButton = "_sk-0";
export var thumbnailFallback = "_sk-3";
export var thumbnailImage = "_sk-2";